export default __webpack_public_path__ + "static/media/testimonials-bg.ad53899f.jpg";